import { summaryRowClassName, summaryRowColumns } from '@/pages/onboarding/onboarding.styles';
import type { SummaryRowProps } from '@/pages/onboarding/onboarding.types';
import { Button, Grid, Text } from '@careflux/primitives';

export const SummaryRow = ({ label, value, editLabel, onEdit }: SummaryRowProps) => (
  <Grid
    templateColumns={summaryRowColumns}
    gap="sm"
    alignItems="baseline"
    paddingY="sm"
    className={summaryRowClassName}
  >
    <Text asChild size="sm" color="muted">
      <dt>{label}</dt>
    </Text>
    <Text asChild size="sm" weight="medium">
      <dd>{value}</dd>
    </Text>
    <dd>
      <Button variant="link" size="sm" onClick={onEdit} aria-label={`${editLabel}: ${label}`}>
        {editLabel}
      </Button>
    </dd>
  </Grid>
);
